import React from "react";
import { IconContainer } from "./IconContainer";

export const PlusCircleIcon = ({ ...props }) => (
  <IconContainer {...props} viewBox="0 0 16 16">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00156 14.4C11.5362 14.4 14.4016 11.5346 14.4016 7.99998C14.4016 4.46535 11.5362 1.59998 8.00156 1.59998C4.46694 1.59998 1.60156 4.46535 1.60156 7.99998C1.60156 11.5346 4.46694 14.4 8.00156 14.4ZM8.60156 5.39998C8.60156 5.0686 8.33293 4.79998 8.00156 4.79998C7.67019 4.79998 7.40156 5.0686 7.40156 5.39998V7.39998H5.40156C5.07019 7.39998 4.80156 7.6686 4.80156 7.99998C4.80156 8.33135 5.07019 8.59998 5.40156 8.59998H7.40156V10.6C7.40156 10.9313 7.67019 11.2 8.00156 11.2C8.33293 11.2 8.60156 10.9313 8.60156 10.6V8.59998H10.6016C10.9329 8.59998 11.2016 8.33135 11.2016 7.99998C11.2016 7.6686 10.9329 7.39998 10.6016 7.39998H8.60156V5.39998Z"
      fill="currentColor"
    />
  </IconContainer>
);
